module.exports = __webpack_public_path__ + "img/19.47e3adde.png";